import { GenresData, VenueTypesData, VenueData, CustomPlaylist } from "@/types";
import { PlaylistState } from "@/types/store/clientzone/playlist";

export const state: PlaylistState = {
  venueTypes: [] as Array<VenueTypesData>,
  genres: [] as Array<GenresData>,
  selectedVenue: {} as VenueData,
  customPlaylist: {} as CustomPlaylist
}
